import axios, { AxiosHeaders } from "axios";
import { clearToken, getToken } from "./auth";
import { captureException, captureMessage } from "./sentry";

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    const headers =
      config.headers instanceof AxiosHeaders
        ? config.headers
        : new AxiosHeaders(config.headers);
    headers.set("Authorization", `Bearer ${token}`);
    config.headers = headers;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status as number | undefined;

    if (!status || status >= 500) {
      captureException(error, (scope) => {
        scope.setTag?.("origin", "axios.response");
        scope.setContext?.("http", {
          method: error?.config?.method ?? "unknown",
          url: error?.config?.url ?? "unknown",
          status: status ?? 0,
        });
      });
    }

    if (error?.response?.status === 401 && typeof window !== "undefined") {
      captureMessage("Authentication failure: unauthorized API response", "warning", (scope) => {
        scope.setTag?.("origin", "axios.response");
        scope.setContext?.("http", {
          method: error?.config?.method ?? "unknown",
          url: error?.config?.url ?? "unknown",
          status: 401,
        });
      });
      clearToken();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
